import React, { useEffect, useState } from "react";
import "../style.css";
import FulfilmentFilters from "./filters";
import moment from "moment";
import FulfilmentCardDetail from "./cardDetail";
import MonthList from "./monthList";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../general/spinner";
import { getBackofficeFulfilments } from "../../../store/actions/fulfilments/presets";
import { getFulfilmentCustomers } from "../../../store/actions/fulfilments/customers";
import { reworkFulfilments } from "../utils";
import FulfilmentCreateDialog from "../create";
import LoaderSimple from "../../general/loader";
import { displaySuccessToast } from "../../../store/actions/overflowNotification";
import { FEATURE_TOGGLE_ONLY_DEV_TEST } from "../../../config";
import { Button } from "@ts-digital/vrc";
import { getFulfilments } from "../../../store/actions/fulfilments";
import VaporNotification from "../../vapor/notification";
import VaporOverlay from "../../vapor/overlay";
import { multipleLinkFulfilmentToCustomer } from "../../../store/actions/fulfilments/links";
import { FormattedMessage } from "react-intl";

const FulfilmentList = props => {
  const {
    firstLoaded,
    setFirstLoaded,    
    reloadData,
    customerId,
    customerItemId,
    setCustomerId
  } = props;

  const dispatch = useDispatch();
  const fulfilments = useSelector(state => state.fulfilments);
  const filteredCustomers = useSelector(state => state.fulfilments.filteredCustomers);
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const isGettingFulfilments = fulfilments
    ? fulfilments.isGettingFulfilments
    : false;
  const fulfilmentsList = fulfilments ? fulfilments.fulfilments : [];
  const companies = fulfilments ? fulfilments.fulfilmentCustomers : [];

  const [cardSelected, setCardSelected] = useState("");
  const [searchValue, setSearchValue] = useState(null);
  const [dateFromValue, setDateFromValue] = useState(null);
  const [dateToValue, setDateToValue] = useState(null);
  const [fulfilmentAddDialog, setFulfilmentAddDialog] = useState(false);
  const [fulfilmentEditDialog, setFulfilmentEditDialog] = useState(false);
  const [fulfilmentRemoveDialog, setFulfilmentRemoveDialog] = useState(false);
  const [showPrevious, setShowPrevious] = useState(true);
  const [previousFulfilments, setPreviousFulfilments] = useState([]);
  const [savingSpinner, setSavingSpinner] = useState(false);

  const calcCardToSelect = arrayFulfilments => {
    let cardToSelect = null;
    arrayFulfilments.map(fulfilment => {
      if (
        !cardToSelect &&
        fulfilment.fulfilmentCompaniesCompleted < fulfilment.fulfilmentCompanies
      ) {
        cardToSelect = fulfilment.fulfilmentId;
      }
      return null;
    });
    return cardToSelect;
  };

  useEffect(() => {
    if (fulfilments.fulfilments && fulfilments.fulfilments.length !== 0) {
      let cardToSelect = null;
      if (cardSelected === "") {
        cardToSelect = calcCardToSelect(fulfilmentsList);
        setCardSelected(cardToSelect);
      }
      dispatch(getFulfilmentCustomers(
        auth,
        cardSelected === "" ? cardToSelect : cardSelected,
        main.accountantUuidSelected
      ));
      function compare(a, b) {
        if (a.fulfilmentDeadline < b.fulfilmentDeadline) {
          return -1;
        }
        if (a.fulfilmentDeadline > b.fulfilmentDeadline) {
          return 1;
        }
        return 0;
      }
      fulfilmentsList.sort(compare);
    }
    if (fulfilments.fulfilments && !firstLoaded) {
      checkFirstLoadSctoll();
    }
  }, [fulfilments.fulfilments, cardSelected]);

  useEffect(() => {
    if (fulfilmentAddDialog) {
      dispatch(getBackofficeFulfilments(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected
      ));
    }
  }, [fulfilmentAddDialog]);

  useEffect(() => {
    if (fulfilments.fulfilments) {
      let prevF = [];
      fulfilments.fulfilments.map(fulfil => {
        if (
          moment(moment(fulfil.fulfilmentDeadline).format("YYYY-MM-01"))
            .endOf("month")
            .isBefore()
        ) {
          prevF.push(moment(fulfil.fulfilmentDeadline).format("YYYYMM"));
        }
        return null;
      });
      if (prevF.length > 0) {
        let prevFToDelete = [];
        prevF.map(it => {
          let cn = 0;
          fulfilments.fulfilments.map(item => {
            let checkJump = true;
            if (
              moment(item.fulfilmentDeadline).format("YYYYMM") === it &&
              item.fulfilmentCompaniesCompleted === item.fulfilmentCompanies
            ) {
              checkJump = false;
            }
            if (
              item.fulfilmentCompaniesCompleted < item.fulfilmentCompanies &&
              moment(item.fulfilmentDeadline).format("YYYYMM") === it &&
              !moment(item.fulfilmentDeadline).isBefore()
            ) {
              checkJump = false;
            }
            if (!checkJump) {
              cn++;
            }
            return null;
          });
          if (cn === 0) {
            prevFToDelete.push(it);
          }
          return null;
        });
        if (prevF.length > prevFToDelete.length) {
          setPreviousFulfilments(prevF);
        }
      }
    }
  }, [fulfilments.fulfilments]);

  useEffect(() => {
    if (!fulfilments.isGettingFulfilments) {
      if (!customerId) {
        dispatch(getFulfilments({ auth, managerId: main.accountantUuidSelected }));
      } else {
        const findCustomer = filteredCustomers.find(x => x.id === customerId);
        if (findCustomer) {
          dispatch(getFulfilments({
            auth,
            managerId: main.accountantUuidSelected,
            itemId: findCustomer.itemId
          }));
        }
      }
    }
  }, [customerId]);

  useEffect(() => {
    if (fulfilmentRemoveDialog && customerItemId) {
      VaporNotification({
        title: "Rimuovi adempimento",
        duration: 0,
        type: "warning",
        size: "large",
        onClose: () => setFulfilmentRemoveDialog(null),
        onConfirm: () => {
          setSavingSpinner(true);
          dispatch(multipleLinkFulfilmentToCustomer(
            auth,
            main.accountantUuidSelected,
            main.companyUuidSelected,
            fulfilmentRemoveDialog,
            [{ customerId: customerId, type: "unlink" }]
          )).then(res => {
            setTimeout(() => {
              setSavingSpinner(false);
              dispatch(displaySuccessToast("Adempimento rimosso con successo"));
              dispatch(getFulfilments({
                auth,
                managerId: main.accountantUuidSelected,
                itemId: customerItemId
              }));
            }, 500);
          });
        },
        overlay: true,
        confirm: true,
        description:
          "Attenzione, l'eliminazione di questo adempimento è irreversibile, non sarà possibile ripristinarlo"
      });
    }
  }, [fulfilmentRemoveDialog]);

  const checkFirstLoadSctoll = () => {
    if (fulfilments.fulfilments && !firstLoaded) {
      let fulfilmentsToCheck = reworkFulfilments(fulfilments.fulfilments);
      let fulfilmentToGo = "";
      if (fulfilmentsToCheck) {
        let monthKeys = Object.keys(fulfilmentsToCheck).reverse();
        monthKeys.forEach(val => {
          if (parseInt(val) >= parseInt(moment().format("YYYYMM"))) {
            fulfilmentToGo = val;
          }
        });
      }
      if (fulfilmentToGo !== "") {
        let docObj = document.getElementById("dbx-fulfilments-section-title_" + fulfilmentToGo);
        docObj.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      setFirstLoaded(true);
    }
  };

  function getMonths() {
    let months = [];
    if (fulfilmentsList) {
      // Primo loop per trovare almeno un adempimento da completare e inserirlo nel mese
      fulfilmentsList.map(fulfil => {
        if (
          fulfil.fulfilmentCompaniesCompleted < fulfil.fulfilmentCompanies &&
          months.length === 0
        ) {
          months.push(moment().format("YYYYMM"));
        }
        return null;
      });
      // Secondo loop per aggiungere i mesi da mostrare in sezioni
      fulfilmentsList.map(fulfil => {
        let fulfilmentMonth = moment(fulfil.fulfilmentDeadline).format("YYYYMM");
        if (
          months.indexOf(fulfilmentMonth) === -1 &&
          (showPrevious ||
            (!showPrevious &&
              moment(moment(fulfil.fulfilmentDeadline).format("YYYY-MM-") + "01").isSameOrAfter(moment().format("YYYY-MM-DD"), "month")))
        ) {
          months.push(fulfilmentMonth);
        }
        return null;
      });
    }
    return months.sort();
  }

  function getFirstMonth(fulfilmentsMonths) {
    let firstMonth = null;
    if (fulfilmentsMonths) {
      fulfilmentsMonths.map(month => {
        if (
          moment(month + "01").isSameOrAfter(moment().format("YYYYMMDD"),
            "month") &&
          !firstMonth
        ) {
          firstMonth = month;
        }
        return null;
      });
      if (!firstMonth) {
        firstMonth = fulfilmentsMonths[0];
      }
    }
    return firstMonth;
  }

  const fulfilmentsMonths = getMonths();
  const firstMonth = getFirstMonth(fulfilmentsMonths);

  const fulfilmentFind = fulfilmentsList?.find(el => el.fulfilmentId === cardSelected);

  return (
    <div style={{ padding: 16 }}>
      {savingSpinner && (
        <VaporOverlay visible={savingSpinner}>
          <LoaderSimple message="Salvataggio modifiche in corso..." />
        </VaporOverlay>
      )}
      <div>
        <FulfilmentFilters          
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          dateFromValue={dateFromValue}
          setDateFromValue={setDateFromValue}
          dateToValue={dateToValue}
          setDateToValue={setDateToValue}
          accountantUuidSelected={main.accountantUuidSelected}
          customerId={customerId}
          setCustomerId={setCustomerId}
          setFirstLoaded={setFirstLoaded}
        />
      </div>
      <div style={{ display: "flex" }}>
        {isGettingFulfilments ? (
          <Spinner
            size="large"
            tip={
              <span>
                <FormattedMessage id="generic.loading1" /> <br /> <FormattedMessage id="generic.loading2" />
              </span>
            }
          />
        ) : fulfilmentsList ? (
          <>
            <div
              id="fulfilment-monthList-container"
              className={
                "fulfilment-monthList-container" +
                (showPrevious || previousFulfilments.length === 0
                  ? " showPrevious"
                  : "") +
                (customerId ? " fullWidth" : "")
              }
            >
              {previousFulfilments.length > 0 && !showPrevious && (
                <div
                  onClick={() => setShowPrevious(true)}
                  className="buttonInfiniteScroll"
                >
                  Mostra adempimenti passati
                </div>
              )}
              {fulfilmentsMonths.map(month => {
                return (
                  <MonthList
                    key={"fulfilment-monthList_" + month}
                    cardSelected={cardSelected}
                    setCardSelected={setCardSelected}
                    setFulfilmentAddDialog={setFulfilmentAddDialog}
                    fulfilments={fulfilmentsList}
                    month={month}                    
                    firstMonth={firstMonth}
                    setFulfilmentEditDialog={setFulfilmentEditDialog}
                    setFulfilmentRemoveDialog={setFulfilmentRemoveDialog}
                    customerId={customerId}
                  />
                );
              })}
              {fulfilmentsMonths.length === 0 && (
                <div className="dbx-fulfilments-list-empty">
                  <div>Non sono stati trovati adempimenti</div>
                  {FEATURE_TOGGLE_ONLY_DEV_TEST === "true" && (
                    <div>
                      <Button
                        kind="tertiary"
                        onClick={() =>
                          setFulfilmentAddDialog(parseInt(moment().format("YYYYMM")))
                        }
                      >
                        Aggiungi adempimento
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
            {!customerId && (
              <div className={"fulfilment-card-detail-container"}>
                {companies && !fulfilments.isGettingFulfilmentCustomers && (
                  <FulfilmentCardDetail
                    companies={companies}                    
                    isFulfilmentNotCompleted={
                      cardSelected === ""
                        ? fulfilmentsList[0].fulfilmentCompletedActivities <
                          fulfilmentsList[0].fulfilmentActivities
                        : fulfilmentFind &&
                          fulfilmentFind.fulfilmentCompletedActivities <
                            fulfilmentFind.fulfilmentActivities
                    }
                  />
                )}
                {fulfilments.isGettingFulfilmentCustomers && (
                  <div className="fulfilment-card-detail-spinner">
                    <LoaderSimple />
                  </div>
                )}
              </div>
            )}
          </>
        ) : null}
      </div>
      {fulfilmentAddDialog ? (
        <FulfilmentCreateDialog
          customerId={customerId}
          onClose={reload => {
            setFulfilmentAddDialog(false);
            if (reload) {
              dispatch(displaySuccessToast("Modifiche effettuate con successo"));
              reloadData();
            }
          }}
          visible={fulfilmentAddDialog !== false}
          month={fulfilmentAddDialog}
        />
      ) : fulfilmentEditDialog ? (
        <FulfilmentCreateDialog
          customerId={customerId}
          onClose={reload => {
            setFulfilmentEditDialog(false);
            if (reload) {
              dispatch(displaySuccessToast("Modifiche effettuate con successo"));
              reloadData();
            }
          }}
          visible={fulfilmentEditDialog}
          editMode
          fulfilmentId={fulfilmentEditDialog}
        />
      ) : null}
    </div>
  );
};

export default FulfilmentList;
